import React, { useState } from 'react'
import { MessageSquare } from 'lucide-react'
import FeedbackModal from './FeedbackModal'

/**
 * Floating feedback button - always visible in bottom-right corner
 * Following Design Principles: Affordance, Consistency
 */
const FeedbackButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      {/* Floating Button - Bottom Right (Principle: Affordance, Consistency) */}
      {/* Mobile: Icon-only circular FAB | Desktop: Button with text */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 flex items-center justify-center gap-2 px-3 py-3 sm:px-4 bg-white border border-gray-200 text-gray-500 rounded-full sm:rounded-lg shadow-sm hover:text-gray-700 hover:scale-105 transition-all duration-200 group"
        aria-label="Send feedback"
      >
        <MessageSquare className="w-5 h-5 sm:w-4 sm:h-4 group-hover:scale-110 transition-transform duration-200" />
        <span className="hidden sm:inline font-medium">Feedback</span>
      </button>

      {/* Modal */}
      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  )
}

export default FeedbackButton
